// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"28":"bb23172c","253":"f8d674d0","723":"f2b7244b","832":"4fdd2a27","927":"56cb80b0"}[chunkId] + ".js";
};